{
  "tabs": {
    "chat": "Chat",
    "reminders": "Recordatorios",
    "calendar": "Calendario",
    "settings": "Ajustes"
  },
  "common": {
    "cancel": "Cancelar",
    "save": "Guardar",
    "confirm": "Confirmar",
    "delete": "Eliminar",
    "back": "Atrás",
    "close": "Cerrar",
    "edit": "Editar",
    "search": "Buscar",
    "all": "Todo",
    "loading": "Cargando...",
    "error": "Algo salió mal",
    "notFound": "No encontrado",
    "tryAgain": "Por favor, inténtalo de nuevo",
    "retry": "Reintentar",
    "undo": "Deshacer",
    "pullToRefresh": "Desliza para actualizar",
    "justNow": "justo ahora"
  },
  "auth": {
    "welcome": "Bienvenido a FishMemory",
    "tagline": "Tu asistente de recordatorios de WhatsApp, ahora en tu bolsillo.",
    "subtitle": "Tu asistente de recordatorios de WhatsApp, ahora en tu bolsillo.",
    "phoneLabel": "Tu número de WhatsApp",
    "phoneHint": "Enviaremos un código de verificación por WhatsApp",
    "invalidPhone": "Por favor, ingresa un número de teléfono válido",
    "continue": "Continuar",
    "enterPhone": "Ingresa tu número de WhatsApp",
    "phonePlaceholder": "Número de teléfono",
    "sendCode": "Enviar código",
    "verifyTitle": "Verifica tu número",
    "otpSentTo": "Se envió un código de 6 dígitos a {{phone}} vía WhatsApp",
    "enterFullCode": "Por favor, ingresa los 6 dígitos",
    "invalidOtp": "Código inválido. Inténtalo de nuevo.",
    "otpFailed": "Error al enviar el código. Inténtalo de nuevo.",
    "otpResent": "Código reenviado",
    "resendIn": "Reenviar en {{seconds}}s",
    "resendCode": "Reenviar código",
    "enterOtp": "Ingresa el código enviado a tu WhatsApp",
    "verify": "Verificar",
    "resend": "Reenviar código",
    "wrongNumber": "¿Número incorrecto?",
    "backToPhone": "Volver al teléfono",
    "editPhone": "Editar número",
    "error": "Error",
    "setupTitle": "Vamos a configurarlo",
    "setupSubtitle": "Puedes cambiar esto luego en Ajustes",
    "namePlaceholder": "Tu nombre",
    "letsGo": "Finalizar configuración",
    "skipForNow": "Saltar por ahora"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Escribe un mensaje...",
    "inputPlaceholder": "Escribe un mensaje...",
    "typing": "FishMemory está escribiendo...",
    "online": "En línea",
    "connecting": "Conectando...",
    "reconnecting": "Reconectando...",
    "offline": "Desconectado",
    "empty": "Inicia una conversación",
    "emptyHint": "Crea recordatorios, revisa tu agenda o pide ayuda.",
    "emptyAction": "Enviar recordatorio de ejemplo",
    "actions": "Acciones de chat",
    "keep": "Mantener mensajes",
    "clearTitle": "Borrar chat",
    "clearConfirm": "¿Eliminar todos los mensajes de este dispositivo? Esto no se puede deshacer.",
    "clear": "Borrar chat",
    "optionSelected": "Seleccionado: {{label}}",
    "sendingSelection": "Enviando...",
    "connectionLost": "Reconectando..."
  },
  "reminders": {
    "title": "Mis Recordatorios",
    "active": "Activos",
    "today": "Hoy",
    "thisWeek": "Esta semana",
    "history": "Historial",
    "items": "elementos",
    "emptyTitle": "Aún no hay recordatorios",
    "emptySubtitle": "Crea uno desde el chat y aparecerá aquí.",
    "emptyAction": "Abrir chat",
    "filterActive": "Activos",
    "filterToday": "Hoy",
    "filterWeek": "Esta semana",
    "filterHistory": "Historial",
    "emptyState": "No hay recordatorios aún. ¡Empieza a chatear!",
    "swipeDone": "Hecho",
    "swipeSnooze": "Posponer",
    "swipeDelete": "Eliminar",
    "search": "Buscar recordatorios...",
    "upcoming": "Próximos",
    "completed": "Completados",
    "overdue": "Vencidos",
    "tomorrow": "Mañana",
    "synced": "Sincronizado {{value}}",
    "swipeHint": "Desliza un recordatorio para más acciones",
    "noResults": "No hay recordatorios que coincidan con tu búsqueda",
    "noResultsHint": "Prueba otra palabra clave o borra la búsqueda",
    "deleteAllFailed": "Error al eliminar todos los recordatorios"
  },
  "calendar": {
    "title": "Calendario",
    "today": "Hoy",
    "tomorrow": "Mañana",
    "completed": "hecho",
    "noEvents": "Nada programado",
    "noEventsSubtitle": "Elige una fecha para ver recordatorios y eventos.",
    "googleEvent": "Google Calendar",
    "legendActive": "Activo",
    "legendRecurring": "Recurrente",
    "legendDone": "Hecho",
    "legendGoogle": "Google",
    "previousMonth": "Mes anterior",
    "nextMonth": "Mes siguiente",
    "previousYear": "Año anterior",
    "nextYear": "Año siguiente",
    "goToToday": "Ir a hoy",
    "all": "Todo",
    "active": "Activo",
    "done": "Hecho",
    "paused": "Pausado"
  },
  "settings": {
    "title": "Ajustes",
    "profile": "Perfil",
    "name": "Nombre visible",
    "enterName": "Ingresa tu nombre",
    "language": "Idioma",
    "uiLanguage": "Idioma de la app",
    "uiLanguageHelp": "Cambia la interfaz, etiquetas del calendario y dirección del texto solo en este dispositivo.",
    "serverLanguage": "Idioma del chat",
    "serverLanguageHelp": "Cambia el idioma de las respuestas del servidor y mensajes de recordatorio para tu cuenta.",
    "timezone": "Zona horaria",
    "currentTimezone": "Zona horaria actual",
    "timezoneHelp": "Todos los horarios de recordatorios se muestran con esta zona horaria.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Guardar zona horaria",
    "timezoneSaved": "Zona horaria actualizada",
    "detect": "Detectar",
    "detectFailed": "No se pudo detectar la zona horaria",
    "autoDetect": "Detectar automáticamente por GPS",
    "notifications": "Notificaciones",
    "notificationsHelp": "Los recordatorios de seguimiento controlan alertas repetidas tras entregar un recordatorio. Los permisos de notificación se gestionan en la configuración del teléfono.",
    "pushEnabled": "Notificaciones push",
    "autoDoneOnFire": "Marcar como hecho automáticamente al activarse",
    "autoDoneOnFireDesc": "Si está apagado, los recordatorios permanecen activos hasta que los marques como hechos.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "Conectado",
    "googleDisconnected": "No conectado",
    "googleConnectedHelp": "Los nuevos recordatorios pueden sincronizarse automáticamente con tu calendario.",
    "googleDisconnectedHelp": "Conecta Google Calendar para mantener recordatorios y eventos alineados.",
    "googleConnectFailed": "Error al conectar Google Calendar",
    "connected": "Conectado",
    "disconnected": "No conectado",
    "connect": "Conectar",
    "disconnect": "Desconectar",
    "autoSync": "Sincronizar nuevos recordatorios automáticamente",
    "autosync": "Sincronizar nuevos recordatorios automáticamente",
    "subscription": "Suscripción",
    "trialUsed": "Prueba: {{used}}/{{total}} usada",
    "trialStatus": "Prueba disponible",
    "activeStatus": "Suscripción activa",
    "expiredStatus": "Suscripción expirada",
    "unsubscribedStatus": "No suscrito",
    "about": "Acerca de",
    "version": "Versión",
    "logout": "Cerrar sesión",
    "logoutTitle": "Cerrar sesión",
    "logoutConfirm": "¿Seguro que quieres cerrar sesión?",
    "noName": "Sin nombre asignado",
    "serverConnection": "Conexión al servidor",
    "serverUrl": "URL del servidor",
    "serverEdit": "Editar",
    "saveReconnect": "Guardar y reconectar",
    "resetDefault": "Restablecer por defecto",
    "invalidServerUrlTitle": "URL del servidor inválida",
    "invalidServerUrlMessage": "Ingresa una URL válida http o https, por ejemplo https://example.com",
    "uiLanguageChangeFailed": "Error al cambiar el idioma de la app. Inténtalo de nuevo.",
    "serverLanguageChangeFailed": "Error al cambiar el idioma del chat. Inténtalo de nuevo.",
    "timezoneChangeFailed": "Error al cambiar la zona horaria. Inténtalo de nuevo.",
    "autoSyncChangeFailed": "Error al actualizar sincronización automática. Inténtalo de nuevo.",
    "nameChangeFailed": "Error al actualizar el nombre visible. Inténtalo de nuevo.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Detalles del recordatorio",
    "editTime": "Editar hora",
    "rename": "Renombrar",
    "snooze": "Posponer",
    "snooze15": "Posponer 15 minutos",
    "pause": "Pausar",
    "pauseReminder": "Pausar recordatorio",
    "resume": "Reanudar",
    "resumeReminder": "Reanudar recordatorio",
    "skip": "Saltar siguiente",
    "skipOccurrence": "Saltar esta ocurrencia",
    "syncGoogle": "Sincronizar con Google",
    "delete": "Eliminar",
    "deleteTitle": "Eliminar recordatorio",
    "deleteConfirm": "Este recordatorio será eliminado permanentemente.",
    "deleteRecurringTitle": "Eliminar recordatorio recurrente",
    "deleteRecurringMessage": "¿Quieres saltar esta ocurrencia o eliminar toda la serie?",
    "deleteThisOccurrence": "Saltar esta ocurrencia",
    "deleteEntireSeries": "Eliminar toda la serie",
    "done": "Hecho",
    "markDone": "Marcar como hecho",
    "undo": "Restaurar",
    "undoPrompt": "¿Necesitas que esté activo otra vez? Restaúralo ahora.",
    "recurring": "Recurrente",
    "nextRun": "Próxima ejecución",
    "oneTime": "Único",
    "pending": "Pendiente",
    "sent": "Enviado",
    "paused": "Pausado",
    "active": "Activo",
    "snoozed": "Pospuesto",
    "localTime": "Mostrado en tu hora local",
    "recurrence": "Recurrencia",
    "created": "Creado",
    "tags": "Etiquetas",
    "fireCount": "Veces activado",
    "actions": "Acciones",
    "none": "Ninguno",
    "snoozeFailed": "Error al posponer el recordatorio",
    "pauseFailed": "Error al pausar el recordatorio",
    "resumeFailed": "Error al reanudar el recordatorio",
    "skipFailed": "Error al saltar el recordatorio",
    "doneFailed": "Error al marcar el recordatorio como hecho",
    "undoFailed": "Error al restaurar el estado del recordatorio",
    "deleteFailed": "Error al eliminar el recordatorio",
    "rescheduleTitle": "¿Reprogramar?",
    "rescheduleMsg": "Este recordatorio está vencido. ¿Quieres reprogramarlo?",
    "reschedule15": "En 15 minutos",
    "reschedule60": "En 1 hora",
    "keepOverdue": "Mantener como está"
  },
  "onboarding": {
    "slide1Title": "Bienvenido a FishMemory",
    "slide1Sub": "Tu asistente personal de recordatorios — potenciado por WhatsApp y hecho para tu bolsillo.",
    "slide2Title": "Solo chatea naturalmente",
    "slide2Sub": "Escribe recordatorios como piensas: \"Recuérdame llamar a mamá mañana a las 3pm\" — nosotros hacemos el resto.",
    "slide3Title": "Nunca olvides nada",
    "slide3Sub": "Recibe notificaciones puntuales, organiza con etiquetas y mantente al día con lo que importa.",
    "getStarted": "Comenzar",
    "next": "Siguiente",
    "firstReminderTitle": "¡Crea tu primer recordatorio!",
    "firstReminderHint": "Prueba escribiendo algo como:",
    "firstReminderExample": "Recuérdame beber agua mañana a las 9 AM",
    "gotIt": "¡Entendido!",
    "notifRationaleTitle": "Mantente a tiempo",
    "notifRationaleBody": "FishMemory necesita notificaciones para recordarte a tiempo. Solo recibirás alertas de recordatorios que crees.",
    "notifRationaleAllow": "Activar notificaciones",
    "notifRationaleLater": "Quizás luego",
    "swipeHint": "Desliza a la derecha para acciones rápidas →",
    "calendarDragHint": "Arrastra para expandir ↕"
  }
}
